import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DraggableModal from '../UI/DraggableModal';

export default function ConfirmModal({ show, onClose, onConfirm, headerText, message, loading }) {
  return (
    <DraggableModal show={show} headerNode={headerText} size="lg" onHide={onClose}>

      <Modal.Body>
        <p>{ message }</p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} disabled={loading} variant="outline-secondary">Отмена</Button>
        <Button onClick={!loading ? onConfirm : null} disabled={loading} variant="primary">Да</Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
